// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__g2IT0","spinner":"loading_spinner__oI_JS"};